<template>
    <div>
        <div v-show="!formdisabled">
            <h5>{{ $t('objects.picker.equipment-list') }}</h5>
            <bryntum-grid
                ref                 = "grid"
                v-bind = "gridConfig"
            >
            </bryntum-grid>
            <div>
                &nbsp;
            </div>
        </div>
        <div>
            <h5>{{ $t('objects.picker.equipment-chosen') }}</h5>
            <bryntum-grid
                ref                 = "gridTarget"
                v-bind = "gridConfigTarget"
            >
            </bryntum-grid>
        </div>
    </div>
</template>

<script>
import { BryntumGrid } from '@bryntum/schedulerpro-vue';
import { GridStateManager } from '../../ashnet-components/plugins/grid/GridStateManager.js';

import RmsObjectsGridColumnCurrentOrders from '../rmsobjects/rms-objects-grid-column-current-orders.js';
import RmsObjectsGridColumnCurrentAvailability from '../rmsobjects/rms-objects-grid-column-current-availability.js';
import RmsObjectsGridColumnExpectedReturn from '../rmsobjects/rms-objects-grid-column-expected-return.js';
import {$t} from "../../i18Instance";

export default {
    name: "object-picker-br",
    props: ['presetobjectid', 'presetobjects', 'formdisabled', 'availabilityDates', 'mode', 'pickType', 'orderid', 'singleSelection'],
    components: {
        BryntumGrid
    },
    data: function () {
        return {
            gridName: 'ashrms-rmsobject-picker-source-grid-state',
            dates:{
                from: '',
                until: ''
            },
            initialLoadDone: false,
            itemTemplate: '<img class="customer-photo-select" src="#= image #" />#= number # #= name # #= desc #',
            optionLabelTemplate: '#= combined_value #',
            blankItem: {
                id: null,
                combined_value: this.$t('general.please_choose')
            },
            schemaModelFields: {
                id: { editable: false, nullable: true },
                name: { validation: { required: true } },
                desc: { validation: { required: true } },
                image: { validation: { required: true } }
            },
            tempObjectIdForAddingToList: 0,
            selectedObject: 0,
            barcodeWindowVisible: true,


            gridDataLoaded: false,
            toolBarHandlersAdded: false,
            displayColumns: [],


            gridConfigTarget:{
                minHeight: '22em',

                imageColumn:[
                    { id: 'g-image', text : this.$t('objects.grid.image'),             locked: true,                   type  : 'imageColumn',          editor : false, width: 100, filterable: false, sortable: false},
                ],

                baseColumns: [
                    { id: 'g-category', text : this.$t('objects.grid.category'),          field : 'categoryName',         editor : false, width: 100, cellCls: 'ash-bold', tooltipRenderer: ({ record }) => { if('description' in record.category){ let tr = this.$t('cstrings.' + record.category.description); if(tr != 'cstrings.'){ return tr}else{return record.category.description}}}},
                    { id: 'g-number', text : this.$t('objects.grid.number'),            locked: true,                   field : 'number',               editor : false, width: 150},
                    { id: 'g-name', text : this.$t('objects.grid.name'),              locked: true,                   field : 'name',                 editor : false, width: 200},
                    { id: 'g-type', text : this.$t('objects.grid.type'),              field : 'rmsObjectType',        editor : false, width: 200},
                    { id: 'g-condition', text : this.$t('objects.grid.condition'),         field : 'condition',            editor : () =>{
                      if(this.mode == 'checkin' || this.mode == 'display'){
                        return true
                      }
                      return false
                      },
                      width: 250},
                    { id: 'g-desc', text : this.$t('objects.grid.description'),       field : 'desc',                 editor : false, width: 250},
                    { id: 'g-inventory-number', text : this.$t('objects.grid.inventory-number'),  field : 'inventory_number',     editor : false, width: 150},
                    { id: 'g-tags', text : this.$t('objects.grid.tags'),              field : 'tagList',              editor : false, width: 250},
                    { id: 'g-location', text : this.$t('objects.grid.location'),          field : 'locationName',         editor : false, width: 200},
                ],
                availabilityColumns: [
                    { id: 'g-rents-in-date', text : this.$t('objects.grid.request-orders-in-selected-time'),
                        width: 300,
                        filterable: false,
                        sortable: false,
                        field: 'hasRentsOrRequestsInDate',
                        align: 'left',
                        cellCls: 'custom-cell-image',
                        editor: false,
                        htmlEncode: false,
                        renderer : ({ record, value, cellElement, row, size }) => {
                            if(value === true){
                                let validEntriesFound = 0;
                                let retValue = '<div>';
                                // Hat Anträge im Zeitraum
                                for (const rentInDate of record.requestsInDate) {
                                    if(rentInDate.id != this.orderid) {
                                        row.addCls('row-restricted-availability');
                                        row.removeCls('row-not-available');
                                        retValue += "<div style=\"margin-bottom:8px;\">";
                                        retValue += "<a target='_blank' href='" + APP_URL + "/#/request-approve/" + rentInDate.id + "'>" + rentInDate.request_number + "</a> - " + rentInDate.desc + "</br>";
                                        retValue += $t('requests.grid.timeframe') + ": " + moment(rentInDate.from).format(AshnetApp.dateTimeFormat) + " - " + moment(rentInDate.until).format(AshnetApp.dateTimeFormat) + "</br>";
                                        retValue += "</div>";
                                        // Für jeden Eintrag 25 Pixel in der Höhe dazurechnen
                                        size.height += 50;
                                        validEntriesFound++;
                                    }
                                }

                                // Hat Aufträge im Zeitraum
                                for (const rentInDate of record.rentsInDate) {
                                    if(rentInDate.id != this.orderid) {
                                        row.addCls('row-not-available');
                                        row.removeCls('row-restricted-availability');
                                        retValue += "<div style=\"margin-bottom:8px;\">";
                                        retValue += "<a target='_blank' href='" + APP_URL + "/#/order-display/" + rentInDate.id + "'>" + rentInDate.number + "</a> - " + rentInDate.desc + "</br>";
                                        retValue += $t('requests.grid.timeframe') + ": " + moment(rentInDate.from).format(AshnetApp.dateTimeFormat) + " - " + moment(rentInDate.until).format(AshnetApp.dateTimeFormat) + "</br>";
                                        retValue += "</div>";
                                        // Für jeden Eintrag 25 Pixel in der Höhe dazurechnen
                                        size.height += 50;
                                        validEntriesFound++;
                                    }
                                }
                                retValue+='</div>';

                                if(validEntriesFound == 0){
                                    return $t('requests.grid.none-available');
                                }

                                return retValue;
                            }else{
                                row.removeCls('row-restricted-availability');
                                row.removeCls('row-not-available');
                                return $t('requests.grid.none-available');
                            }
                        }

                    },
                    { id: 'g-current-status', text : this.$t('objects.grid.current-state'),                     type  : 'currentStatusColumn',                  width: 180, filterable: false, sortable: false},
                    { id: 'g-requestable', text : this.$t('objects.grid.available-for-rent-requests'),       type  : 'requestableColumn',                    editor : false, width: 150},
                ],
                resourceNoteColumns: [
                    { id:'g-availability-in-selected-time', text : this.$t('objects.grid.availability-in-selected-time'),     type  : 'currentAvailabilityColumn',            width: 130},
                    { id:'g-expected-return', text : this.$t('objects.grid.expected-return'),     type  : 'expectedReturnDate',            width: 150},
                ],
                columns:[{}],
                actionColumn :
                    {
                        id: 'g-action-delete',
                        type    : 'action',
                        width   : 60,
                        text    : '',
                        locked  : true,
                        actions : [{
                            cls     : 'fad fa-trash fa-lg',
                            tooltip : this.$t('objects.picker.equipment-remove-from-order'),
                            onClick : ({ record }) => {
                                event.preventDefault(); // Prevents URL change or submit of form
                                this.onDeleteAction(record)
                            }
                        }]
                    },
                store: {
                    syncDataOnLoad: false,
                    data: [],
                    useRestfulMethods: true,
                    autoLoad: false,
                    autoCommit: false,
                    useRawData: true,
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
                        'X-Requested-With': 'XMLHttpRequest',
                        'X-XSRF-TOKEN': $('meta[name="xsrf-token"]').attr('content')
                    },
                    listeners:{
                      change: (e)=>{
                        this.onRmsObjectChanged(e);
                      }
                    }

                },
                selectionMode: {
                    row: true,
                    cell: false,
                    rowCheckboxSelection: false,
                    multiSelect: false,
                    checkbox: false,
                    showCheckAll: false
                },

                fixedRowHeight : false,

                headerMenuFeature: false,
                filterBarFeature: false,
                cellTooltipFeature: true,
                cellMenuFeature : false,
            },

            gridConfig:{
                subGridConfigs : {
                    locked : { },
                    normal : { }
                },

                minHeight: '34em',

                imageColumn:[
                    { id:'g-image', locked: true, text : this.$t('objects.grid.image'),             type  : 'imageColumn',          editor : false, width: 100, filterable: false, sortable: false},
                ],

                baseColumns: [
                    { id:'g-category', text : this.$t('objects.grid.category'),          field : 'categoryName',         editor : false, width: 100, cellCls: 'ash-bold', tooltipRenderer: ({ record }) => { if('description' in record.category){ let tr = this.$t('cstrings.' + record.category.description); if(tr != 'cstrings.'){ return tr}else{return record.category.description}}}},
                    { id:'g-number', locked: true, text : this.$t('objects.grid.number'),            field : 'number',               editor : false, width: 150},
                    { id:'g-name', locked: true, text : this.$t('objects.grid.name'),              field : 'name',                 editor : false, width: 200},
                    { id:'g-type', text : this.$t('objects.grid.type'),              field : 'rmsObjectType',        editor : false, width: 200},
                    { id:'g-condition', text : this.$t('objects.grid.condition'),         field : 'condition',            editor : false, width: 250},
                    { id:'g-description', text : this.$t('objects.grid.description'),       field : 'desc',                 editor : false, width: 250},
                    { id:'g-inventory-number', text : this.$t('objects.grid.inventory-number'),  field : 'inventory_number',     editor : false, width: 150},
                    { id:'g-tags', text : this.$t('objects.grid.tags'),              field : 'tagList',              editor : false, width: 250},
                    { id:'g-location', text : this.$t('objects.grid.location'),          field : 'locationName',         editor : false, width: 200},
                ],
                availabilityColumns: [
                    {
                        id:'g-request-orders-in-selected-time',
                        text : this.$t('objects.grid.request-orders-in-selected-time'),
                        width: 300,
                        filterable: false,
                        sortable: false,
                        field: 'hasRentsOrRequestsInDate',
                        align: 'left',
                        cellCls: 'custom-cell-image',
                        editor: false,
                        htmlEncode: false,
                        renderer : ({ record, value, cellElement, row, size }) => {
                            if(value === true){
                                let validEntriesFound = 0;
                                let retValue = '<div>';
                                // Hat Anträge im Zeitraum
                                for (const rentInDate of record.requestsInDate) {
                                    if(rentInDate.id != this.orderid) {
                                        row.addCls('row-restricted-availability');
                                        row.removeCls('row-not-available');
                                        retValue += "<div style=\"margin-bottom:8px;\">";
                                        retValue += "<a target='_blank' href='" + APP_URL + "/#/request-approve/" + rentInDate.id + "'>" + rentInDate.request_number + "</a> - " + rentInDate.desc + "</br>";
                                        retValue += $t('requests.grid.timeframe') + ": " + moment(rentInDate.from).format(AshnetApp.dateTimeFormat) + " - " + moment(rentInDate.until).format(AshnetApp.dateTimeFormat) + "</br>";
                                        retValue += "</div>";
                                        // Für jeden Eintrag 25 Pixel in der Höhe dazurechnen
                                        size.height += 50;
                                        validEntriesFound++;
                                    }
                                }

                                // Hat Aufträge im Zeitraum
                                for (const rentInDate of record.rentsInDate) {
                                    if(rentInDate.id != this.orderid) {
                                        row.addCls('row-not-available');
                                        row.removeCls('row-restricted-availability');
                                        retValue += "<div style=\"margin-bottom:8px;\">";
                                        retValue += "<a target='_blank' href='" + APP_URL + "/#/order-display/" + rentInDate.id + "'>" + rentInDate.number + "</a> - " + rentInDate.desc + "</br>";
                                        retValue += $t('requests.grid.timeframe') + ": " + moment(rentInDate.from).format(AshnetApp.dateTimeFormat) + " - " + moment(rentInDate.until).format(AshnetApp.dateTimeFormat) + "</br>";
                                        retValue += "</div>";
                                        // Für jeden Eintrag 25 Pixel in der Höhe dazurechnen
                                        size.height += 50;
                                        validEntriesFound++;
                                    }
                                }
                                retValue+='</div>';

                                if(validEntriesFound == 0){
                                    return $t('requests.grid.none-available');
                                }

                                return retValue;
                            }else{
                                row.removeCls('row-restricted-availability');
                                row.removeCls('row-not-available');
                                return $t('requests.grid.none-available');
                            }
                        }

                    },
                    { id:'g-current-state', text : this.$t('objects.grid.current-state'),                     type  : 'currentStatusColumn',                  width: 180, filterable: false, sortable: false},
                    { id:'g-available-for-rent-requests', text : this.$t('objects.grid.available-for-rent-requests'),       type  : 'requestableColumn',                    editor : false, width: 150},
                ],
                resourceNoteColumns: [
                    { id:'g-availability-in-selected-time', text : this.$t('objects.grid.availability-in-selected-time'),     type  : 'currentAvailabilityColumn',            width: 130},
                    { id:'g-expected-return', text : this.$t('objects.grid.expected-return'),     type  : 'expectedReturnDate',            width: 150},
                ],
                columns:[{}],
                actionColumn :
                    {
                        id      : 'g-action-1',
                        type    : 'action',
                        width   : 60,
                        text    : '',
                        locked  : true,
                        actions : [{
                            visible  : ({ record }) => (record.hasRentsInDate != true || this.pickType == 'order'),
                            cls     : 'fad fa-cart-arrow-down fa-lg',
                            tooltip : this.$t('objects.picker.equipment-add-to-order'),
                            onClick : ({ record }) => {
                                event.preventDefault();
                                this.onRmsObjectAddToOrder(record);
                            }
                        }]
                    },
                store: {
                    syncDataOnLoad: false,
                    useRestfulMethods: true,
                    readUrl: '/api/rmsobjects/clear',
                    deleteUrl: '/api/rmsobjects/delete',
                    pageParamName: 'page',
                    sortParamName: 'sort',
                    filterParamName: 'filter',
                    responseTotalProperty: 'meta.total',
                    pageSize: 25,
                    autoLoad: false,
                    autoCommit: false,
                    useRawData: true,
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
                        'X-Requested-With': 'XMLHttpRequest',
                        'X-XSRF-TOKEN': $('meta[name="xsrf-token"]').attr('content')
                    },
                    listeners: {
                        beforeRequest: (e) =>{
                            console.log("beforeRequest");
                            e.params.availabilityFrom = this.availabilityDates.from;
                            e.params.availabilityUntil = this.availabilityDates.until;
                        },
                    },
                },
                selectionMode: {
                    row: true,
                    cell: false,
                    rowCheckboxSelection: false,
                    multiSelect: false,
                    checkbox: false,
                    showCheckAll: false
                },

                fixedRowHeight : false,
                bbar : {
                    type : 'pagingtoolbar'
                },
                tbar : {
                    items: [

                        {
                            type      : 'text',
                            ref       : 'filterField',
                            clearable : true,
                            label     : '<i class="b-icon b-icon-search"></i> ' + this.$t('objects.picker.quick-search'),
                            width     : 400,
                            cls       : 'b-bright',
                            //onChange  : ({source: filterField}) => this.onFilterFieldChange(filterField),
                            onInput  : ({source: filterField}) => this.onFilterFieldChange(filterField),
                            onClear   : () => this.onFilterFieldClear()
                        },

                        {
                            type        : 'combo',
                            ref         : 'quickFilter',
                            name        : 'type',
                            label       : this.$t('objects.picker.quick-filter'),
                            placeholder : this.$t('objects.picker.quick-filter-inactive'),
                            width       : 600,
                            editable    : false,
                            multiSelect : false,
                            clearable   : true,
                            items       : [
                                { value : '1', text : 'eBikes' },
                                { value : '2', text : 'Devices' },
                                { value : '3', text : 'MKB Carpool' }
                            ],
                            value : '',
                            listeners:{
                                change: (evt) => {
                                    if(evt.value > 0){
                                        this.onQuickFilterSelect(evt.source,evt)
                                    }else{
                                        this.onQuickFilterRemove()
                                    }
                                },
                            }

                        },
                        {
                            type : 'slidetoggle',
                            ref  : 'includeArchiveSlider',
                            hidden : !AshnetApp.can('orders create'),
                            text : this.$t('objects.grid.include-archive'),
                            listeners: {
                                change: this.onChangeArchiveFlag
                            }
                        },
                        {
                            text : this.$t('customers.grid.filter-remove'),
                            icon  : 'fa-tbar fad fa-filter',
                            onClick: () => {
                                //this.$refs.grid.gridInstance.store.clearFilters();
                                this.onFilterReset();
                            }
                        },
                        {
                            text : this.$t('customers.grid.sort-reset'),
                            icon  : 'fa-tbar fad fa-sort-alt',
                            onClick: () => {
                                this.$refs.grid.gridInstance.store.clearSorters();
                            }
                        },
                        {
                            type: 'button',
                            ref: 'clearButton',
                            text : this.$t('customers.grid.column-config-reset'),
                            icon  : 'fa-tbar fad fa-columns',
                            disabled : true
                        },
                        /*
                        {
                            text : 'Alle Filter entfernen',
                            icon  : 'fa-tbar fad fa-filter',
                            onClick: () => this.onFilterReset()
                        },
                        {
                            text : 'Sortierung zurücksetzen',
                            icon  : 'fa-tbar fad fa-sort-alt',
                            onClick: () => this.onSorterReset()
                        }*/
                    ]
                },

                headerMenuFeature: false,
                filterBarFeature: false,
                //searchFeature : true,
                cellTooltipFeature: true,
                cellMenuFeature: false,
            }
        }
    },

    mounted:function (){
        // Das erste Laden der Grids geschieht durch das setzen der Verfügbarkeitsdaten
    },

    watch: {

        availabilityDates:{
            // TODO: wird das hier gebraucht???
            handler: function(newObject, oldObject) {
                this.dates = newObject;
            },
            deep: true
        },

        singleSelection: {
            handler: function(newValue) {
                if (newValue === true) {
                    this.gridConfigTarget.minHeight = '8em';
                } else {
                    this.gridConfigTarget.minHeight = '22em';
                }
            },
            immediate: true
        },

    },
    methods: {

        onFilterFieldChange: _.debounce(function (e) {
            this.performAllColumnFilter(e.value);
        }, 300),

        performAllColumnFilter: function(filterValue){
            // Serverseitige Lösung. Ein spezieller Name "allColumnsFilter" um eine Sonderbehandlung, bzw. die serverseitige suche nach dem Eintrag zu starten
            this.$refs.grid.gridInstance.store.filter({
                id: 'special_search',
                filters: {
                    property: 'special_search',
                    operator: '*',
                    value: filterValue
                },
                replace : false
            });
        },

        onFilterFieldClear: function(){
            console.log("onFilterFieldClear");
            this.$refs.grid.gridInstance.store.removeFilter('special_search');
        },

        onChangeArchiveFlag(evt){
            if(evt.checked){
                this.$refs.grid.gridInstance.store.filter({
                    id: 'search_archived',
                    filters: {
                        property: 'search_archived',
                        operator: '*',
                        value: evt.checked
                    },
                    replace : false
                });

            }else{
                this.$refs.grid.gridInstance.store.removeFilter('search_archived');
                this.$refs.grid.gridInstance.widgetMap.includeArchiveSlider.checked = false; // Nicht mehr im Archiv suchen
            }
        },

        /*
        performAllColumnFilter: function(filterValue){
            // Erstmal alle Filter entfernen
            this.$refs.grid.gridInstance.store.clearFilters();

            // Filter am Komma aufteilen
            var filterArr = filterValue.split(",").map(item => item.trim());

            // Hier das filter Arr durchlaufen und Filter für alle anlegen
            for (const filterArrKey of filterArr) {
                this.$refs.grid.gridInstance.store.filterBy(record => {
                    let lowerCaseFilterValue = filterArrKey.toLowerCase();
                    for (const recordKey in record.data) {
                        if(record.data[recordKey] != null){
                            // In Form-Data suchen
                            if(recordKey == 'form_data'){
                                let tmpData = Object.entries(record.data[recordKey]);
                                for (const tmpDataKey in tmpData) {
                                    if(tmpData[tmpDataKey].toString().toLowerCase().includes(lowerCaseFilterValue)){
                                        return true;
                                    }
                                }
                            }else{
                                if(record.data[recordKey].toString().toLowerCase().includes(lowerCaseFilterValue)){
                                    return true;
                                }
                            }
                        }
                    }
                    return false;
                });
            }
        },*/

        /*
        onFilterFieldClear: function(){
            console.log("onFilterFieldClear");
            this.$refs.grid.gridInstance.store.clearFilters();
        },*/

        onGridStoreLoaded: function(){
            console.log("onGridStoreLoaded");
            this.loadFields();
        },

        onClickCreate: function(){
            location.href = "/objects/create";
        },

        onFilterReset: function () {
            this.$refs.grid.gridInstance.store.removeFilter('special_search');
            this.$refs.grid.gridInstance.widgetMap.filterField.value = null; // Schnellsuch-Feld leeren
            this.$refs.grid.gridInstance.widgetMap.includeArchiveSlider.checked = false; // Nicht mehr im Archiv suchen
            this.$refs.grid.gridInstance.widgetMap.quickFilter.value = null; //schnellfilter combo leeren
            this.$refs.grid.gridInstance.store.clearFilters();
        },

        onSorterReset: function(){
            this.$refs.grid.gridInstance.store.clearSorters();
        },

        onQuickFilterSelect: function(combo, record){
            console.log("onQuickFilterSelect", record);


            if (record) {
                // Spezifische Spalten laden
                this.loadFields(record.value);
                this.$refs.grid.gridInstance.store.filter({
                    id: 'rmsObjectTypeFilter',
                    filters: {
                       property: 'field_set_definition_id',
                       operator: '=',
                       value: record.value
                    },
                    replace : false
                });
                combo.selecting = false;
            } else {
                this.onQuickFilterRemove();
            }
        },

        onQuickFilterRemove: function(){
            this.loadFields();
            this.$refs.grid.gridInstance.store.clearFilters();
        },

        onGroupRmsObjectsChange(evt) {
            console.log("checkbox elem chenge", evt);
            console.log("checkbox elem chenge", evt.checked);

            this.settings.groupRmsObjects = evt.checked;
            if(evt.checked === true){
                console.log("setze gruppierung");
                this.$refs.grid.gridInstance.store.group('rmsObjectType');
            }else{
                console.log("entferne gruppierung");
                this.$refs.grid.gridInstance.store.clearGroupers();
            }
        },

      /**
       * Elemente der Liste wurde geändert. Direkt ändern. (Für Zustand der Leihobjekte)
       * @param e
       */
        onRmsObjectChanged(e) {
          if(e.action && e.record && e.changes)
          {
            axios.put('/api/rmsobjects/updatefields/' + e.record.id, {
              changes: e.changes,
            })
              .then(function (response) {
                console.log(response);
              })
              .catch(function (error) {
                console.log(error);
              });
          }
        },

        onRmsObjectAddToOrder(record){

            let elems = this.$refs.gridTarget.gridInstance.store.allRecords;
            console.log("add", elems.length);
            if(this.singleSelection === true){
               if(elems.length >= 1){
                   swal.fire({
                       title: this.$t('objects.picker.only-one-item-per-service-order-title'),
                       text: this.$t('objects.picker.only-one-item-per-service-order-text'),
                       icon: "warning"
                   });
                   return;
               }
            }

            if(elems.length > 0){
                if(elems.map(function(e) {return e.id;}).indexOf(record.id) === -1) {
                    if(record.id !== null){
                        // nix machen, einfach weiter
                    }
                }else{
                    // Object already in List
                    swal.fire({
                        title: this.$t('objects.picker.item-already-in-list-title'),
                        text: this.$t('objects.picker.item-already-in-list-text'),
                        icon: "warning"
                    });
                    return;
                }
            }

            if(record.id !== null){
                if(this.pickType == "request" && record.category && record.category.is_special === 1){
                    swal.fire({
                        title: this.$t('cstrings.' + record.category.info_title),
                        text: this.$t('cstrings.' + record.category.description),
                        icon: record.category.info_icon,
                        showCancelButton: true,
                        cancelButtonText: this.$t('general.cancel'),
                        confirmButtonText: this.$t('objects.picker.special-add')
                    }).then((hasConfirmed) => {
                        if (hasConfirmed.value) {
                            this.$refs.gridTarget.gridInstance.store.add(record);
                            this.$emit('objectAdd', record);
                        } else {
                            return;
                        }
                    });

                }else{
                    this.$refs.gridTarget.gridInstance.store.add(record);
                    this.$emit('objectAdd', record);
                }
            }
        },






        init: function(){
            console.log("THIS PROPS:", this.$props);
            if(!this.availabilityDates)
                return;

            // Alle Felder laden und zu gridComumns (der Spaltendefinition) hinzufügen
            //window.addEventListener('beforeunload', this.leaving);
            this.$refs.grid.gridInstance.columns.autoAddField = true;
            this.$refs.gridTarget.gridInstance.columns.autoAddField = true;

            // Stores der Grids zurücksetzen
            this.$refs.grid.gridInstance.store.data = [];

            // Nur leeren, wenn das Erste mal geladen wird, sonst werden bestehende Elemente entfernt
            if(!this.initialLoadDone) {
                this.$refs.gridTarget.gridInstance.store.data = [];
                this.initialLoadDone = true;
            }

            // Initiales laden des Grids
            if(this.pickType == "request"){
                // falls es sich um einen Mietantrag handelt
                this.$refs.grid.gridInstance.store.readUrl = '/api/rmsobjects/customfilter/request';
            }else{
                // falls es sich um einen Auftrag handelt
                this.$refs.grid.gridInstance.store.readUrl = '/api/rmsobjects/customfilter/order'
            }
            this.$refs.grid.gridInstance.store.load().then(() => {
                this.loadFields();
                GridStateManager.initForGrid(this.$refs.grid.gridInstance, this.gridName);

                // Bestehende Daten setzen
                this.onObjectListDatabound();
            });

            // TODO: Bestehende Elemente eines Auftrags laden

        },


        reloadStore: function(){
            console.log("reloading store");
            this.init();
        },


        leaving: function(){
            //this.saveGridState();
        },


        // region Dynamische Spalten
        loadFields: function(fieldsId = null){
            /*if(fieldsId != null){
                console.log("lade einzelne Definition");
                axios.get('/api/rmsobjects/fieldsdefinitions/id/' + fieldsId)
                    .then(response => {
                        this.addFields(response.data.field_type);
                        this.$emit('objects-loaded');
                    });
            }else{*/
                console.log("lade alle felder");
                axios.get('/api/rmsobjects/fields')
                    .then(response => {
                        this.addFieldsTarget(response.data);
                        this.addFields(response.data);
                        this.$emit('objects-loaded');
                    });
            //}
        },

        addFields: function(customFields){
            // Alle Spalten entfernen
            this.$refs.grid.gridInstance.columns.removeAll();

            // Basis-Spalten hinzufügen
            this.$refs.grid.gridInstance.columns.add(this.gridConfig.actionColumn);

            this.$refs.grid.gridInstance.columns.add(this.gridConfig.imageColumn);

            // Spalten für Verfügbarkeit nur hinzufügen, wenn der Anfragetyp nicht request ist
            if(this.pickType != 'request'){
                this.$refs.grid.gridInstance.columns.add(this.gridConfig.availabilityColumns)
            }

            if(this.pickType == 'request'){
                this.$refs.grid.gridInstance.columns.add(this.gridConfig.resourceNoteColumns)
            }

            this.$refs.grid.gridInstance.columns.add(this.gridConfig.baseColumns);

            let that = this;
            let colCount = 0;
            customFields.map(function(value, key) {
                if(value.configuration.model != 'name' && value.configuration.model != 'desc' ){

                    let tmpObj = {
                        id: 'g-form-field-' + colCount,
                        text: that.$t("cstrings.colfields."+value.configuration.label),
                        field: 'form_data.' + value.configuration.model,
                        editor : false
                    };
                    that.$refs.grid.gridInstance.columns.add(JSON.parse(JSON.stringify(tmpObj)));
                    colCount++;
                }
            });
            this.$refs.grid.gridInstance.columns.commit();
        },

        addFieldsTarget: function(customFields) {
            console.log("add fields for target");
            // Alle Spalten entfernen
            this.$refs.gridTarget.gridInstance.columns.removeAll();

            // Aktionsspalte nur hinzufügen, wenn nicht form nicht disabled
            if (!this.formdisabled) {
                this.$refs.gridTarget.gridInstance.columns.add(this.gridConfigTarget.actionColumn);
            }

            this.$refs.gridTarget.gridInstance.columns.add(this.gridConfigTarget.imageColumn);

            // Spalten für Verfügbarkeit nur hinzufügen, wenn der Anfragetyp nicht request ist

            if (this.pickType != 'request') {
                this.$refs.gridTarget.gridInstance.columns.add(this.gridConfigTarget.availabilityColumns)
            }


            if(this.pickType == 'request'){
                this.$refs.gridTarget.gridInstance.columns.add(this.gridConfigTarget.resourceNoteColumns)
            }

            // Basis-Spalten hinzufügen
            this.$refs.gridTarget.gridInstance.columns.add(this.gridConfigTarget.baseColumns);


            let that = this;
            customFields.map(function(value, key) {
                if(value.configuration.model != 'name' && value.configuration.model != 'desc' ){

                    let tmpObj = {
                        text: that.$t("cstrings.colfields."+value.configuration.label),
                        field: 'form_data.' + value.configuration.model,
                        editor : false
                    };
                    that.$refs.gridTarget.gridInstance.columns.add(JSON.parse(JSON.stringify(tmpObj)));

                }
            });

            this.$refs.gridTarget.gridInstance.columns.commit();
        },


        /**
         * Setzt das Objekt mit einer bestimmten ID als Verleihobjekt, wenn es beim Laden gesetzt ist. (presetobjectid)
         * Für Schnellanlegen eines Auftrages aus Objektliste
         * @param e
         */
        onObjectListDatabound: function(){
            let elems = this.$refs.gridTarget.gridInstance.store.allRecords;
            if(this.presetobjectid && elems.length <= 0) {
                // TODO: Das Element muss evtl nicht neu geladen werden. Es sollte doch in der Liste oben vorhanden sein. (Oder ist das ein Problem durch Paging - wenn es nicht in der aktuellen Ansicht sichtbar ist... wurde evtl. dann doch noch nicht geladen)
                console.log("loadAndSetPreselectedObject laden", this.presetobjectid);
                this.loadAndSetPreselectedObject(this.presetobjectid);
            }else{
                console.log("preset laden", this.presetobjects);
                this.setPreselectedObjects(this.presetobjects);
            }
        },

        /**
         * Setzt vorausgewählte Elemente eines Bestehenden Auftrags in die Liste (Beim Anzeigen / Bearbeiten)
         */
        setPreselectedObjects: function(rmsObjects){
            console.log("setPreselectedObjects: ", rmsObjects);
            if(rmsObjects && this.$refs.gridTarget.gridInstance.store.allCount == 0) {
                // Elemente in QuellenDatensource suchen und im Grid setzen

                let rmsObjectIds = [];
                for (let rmsObject of rmsObjects) {
                    rmsObjectIds.push(rmsObject.id);
                }
                console.log("setPreselectedObjects IDs: ", rmsObjectIds);
                console.log("setPreselectedObjects availability dates: ", this.availabilityDates);
                if(!this.availabilityDates) {
                    this.availabilityDates = {};
                    this.availabilityDates.from = new moment();
                    this.availabilityDates.until = new moment();
                }
                axios
                    .get('/api/rmsobjects/withCollisions/',{params: {
                            'id':JSON.stringify(rmsObjectIds),
                            'availabilityFrom': this.availabilityDates.from.toString(),
                            'availabilityUntil': this.availabilityDates.until.toString()
                        }})
                    .then(response => {
                        for (let rmsObjectWithCollisions of response.data) {
                            this.$refs.gridTarget.gridInstance.store.add(rmsObjectWithCollisions);
                        }
                    })
                    .catch(error => {
                        console.log("err", error);
                    });
            }
        },

        /**
         * Lädt ein bestimmtes Equipment vom Server und fügt es dem Targetgrid hinzu
         * @param rmsObjectId
         */
        loadAndSetPreselectedObject: function(rmsObjectId){
            if(rmsObjectId){
                console.log("SETTING availabilityDAtes for Target: c", this.availabilityDates);
                axios
                    .get('/api/rmsobjects/withCollisions/',{params: {
                            'id':JSON.stringify(rmsObjectId),
                            'availabilityFrom': this.availabilityDates.from.toString(),
                            'availabilityUntil': this.availabilityDates.until.toString()
                        }})
                    .then(response => {
                        this.$refs.gridTarget.gridInstance.store.add(response.data);
                    })
                    .catch(error => {
                        console.log("err", error);
                    });
            }
        },



        /**
         * Eventhandler zum entfernen eines Objektes aus der Auftragsliste.
         * Nach Abfrage wird das Objekt beibehalten oder entfernt.
         * @param id Id des zu entfernenden Elementes
         */
        onDeleteAction: function(record){
            console.log("deleting id?", record);

            swal.fire({
                title: this.$t('objects.picker.remove-equipment-title'),
                text: this.$t('objects.picker.remove-equipment-text'),
                icon: "warning",
                showCancelButton: true,
                cancelButtonText: this.$t('general.cancel'),
                confirmButtonText: this.$t('general.ok')
            }).then((willDelete) => {
                if (willDelete.value) {
                    this.$refs.gridTarget.gridInstance.store.remove(record);
                    this.$emit('objectRemove', record);
                } else {
                    return;
                }
            });
        },

    }
}
</script>

<style lang="scss" scoped>
@use "sass:math";
.preloader-scan {
    position: relative;
    left: -15px;
    right: 0;
    max-width: 100%;
    display: table;
    margin: 0 auto;
    height: 100%;
    text-align: left;

    @for $i from 1 through 24 {
        li:nth-child(#{$i}){
            $w: math.random(5);
            width: #{$w}px;
        }
    }

    ul {
        height: 100%;
        display: table-cell;
        vertical-align: middle;
        list-style-type: none;
        text-align: center;
    }

    li {
        display: inline-block;
        width: 2px;
        height: 75px;
        background-color: #444;
    }

    .laser {
        width: 150%;
        margin-left: -25%;
        margin-top: -50%;
        background-color: tomato;
        height: 1px;
        position: relative;
        top: 0px;
        z-index: 2;
        box-shadow: 0 0 4px red;
        animation: scanning 2s infinite;
    }

    .diode {
        animation: beam .01s infinite;
    }

}

body {
    height: 100%;
}

@keyframes beam {
    50% {
        opacity: 0;
    }
}

@keyframes scanning {
    50% {
        transform: translateY(75px);
    }
}
</style>
